import { render, staticRenderFns } from "./Dpv.vue?vue&type=template&id=32fbfa36&scoped=true"
import script from "./Dpv.vue?vue&type=script&lang=js"
export * from "./Dpv.vue?vue&type=script&lang=js"
import style0 from "./Dpv.vue?vue&type=style&index=0&id=32fbfa36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbfa36",
  null
  
)

export default component.exports